import { actions } from './actions'
import { api } from '@/shared'
import { message } from 'antd'
import { t } from 'i18next'

export const getPhoneForIin = (payload) => {
	return async (dispatch) => {
		try {
			dispatch(actions.setIinPhone(payload))
			const response = await api.verification.getPhone(payload)
			dispatch(actions.setIinPhoneDone(response))
		} catch (error) {
			dispatch(actions.setIinPhoneFail())
		}
	}
}

export const sendPhoneForIin = (payload) => {
	return async (dispatch) => {
		try {
			dispatch(actions.setSms())
			const response = await api.verification.sendPhone(payload)
			dispatch(actions.setSmsDone())
		} catch (error) {
			message.error(error.response ? error.response.data.message : t('unknown_error'))
			dispatch(actions.setSmsFail())
		}
	}
}

export const getVerificationQR = (payload) => {
	return async (dispatch) => {
		try {
			dispatch(actions.toggleLoading(true))
			dispatch(actions.toggleError(false))
			const { key, qrCode } = await api.verification.getVerificationQR()
			const image = new Image()
			image.src = `data:image/png;base64,${qrCode}`
			image.onload = () => {
				dispatch(actions.setQR(image.src))
				dispatch(actions.setQRKey(key))
			}
			dispatch(actions.toggleSuccess(true))
		} catch (error) {
			dispatch(actions.toggleSuccess(false))
			dispatch(actions.toggleError(true))
		} finally {
			dispatch(actions.toggleLoading(false))
		}
	}
}

export const getStatus = (key) => {
	return async (dispatch) => {
		try {
			const response = await api.verification.getStatusQR(key)
			dispatch(actions.getQRStatus(response))
		} catch (error) {}
	}
}
